export function stringifyQueryParams<T extends object>(params: T) {
  return Object.entries(params)
    .filter(([, value]) => value != null && value !== '')
    .reduce(
      (acc, [key, value], index) =>
        acc + `${index === 0 ? '?' : '&'}${key}=${encodeURIComponent(value)}`,
      '',
    );
}
